module.exports = __webpack_public_path__ + "img/fj.43779f56.svg";